import { render, staticRenderFns } from "./GrowthModule.vue?vue&type=template&id=fd63a0b6"
import script from "./GrowthModule.vue?vue&type=script&lang=ts"
export * from "./GrowthModule.vue?vue&type=script&lang=ts"
import style0 from "./GrowthModule.vue?vue&type=style&index=0&id=fd63a0b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports